
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import LogoSvg from './LogoSvg';

interface LogoProps {
  scrolled: boolean;
}

const Logo: React.FC<LogoProps> = ({ scrolled }) => {
  const { currentLanguage } = useLanguage();
  
  return (
    <Link 
      to={`/${currentLanguage}`} 
      className="flex items-center group py-2 ml-6"
      aria-label="Future Level Homepage"
    >
      <div 
        className={`w-auto mr-4 flex items-center justify-center overflow-hidden transition-all duration-500 transform ${
          scrolled ? 'h-24 scale-[0.92]' : 'h-28 scale-100'
        }`}
      >
        <LogoSvg 
          className={`h-full w-auto transition-all duration-300 hover:scale-105 ${
            scrolled ? 'opacity-95' : 'opacity-100'
          }`}
        />
      </div>
    </Link>
  );
};

export default Logo;
